<template>
  <div class="
      media-img media--img media-img-md
      rounded-full
      d-flex
      align-items-center
      justify-content-center
    ">
    <div class="
        media media-card
        align-items-center
        d-block d-flex
        justify-content-center
        align-items-center
        flex-column
      ">
      <div style="
          border-radius: 100% !important;
          border: 3px solid #6262a1;
          padding: 10px;
        ">
        <img :width="70" :height="70" v-if="ifPicExist(me.Profile)"
          class="rounded-full d-flex align-items-center justify-content-center" :src="domain + me.Profile" />
        <img :width="70" :height="70" v-if="!ifPicExist(me.Profile)"
          class="rounded-full d-flex align-items-center justify-content-center" src="../assets/images/notfound.png" />
      </div>
      <h4 v-if="!loggedOut" class="d-flex align-items-center justify-content-center">
        {{ me.Name }}
      </h4>
      <p class="fs-12 black-text">تخصص: {{ me.SkillType }}</p>
    </div>
  </div>

  <ul v-if="me !== null" class="generic-list-item off-canvas-menu-list off--canvas-menu-list">
    <li>
      <router-link to="/">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-house"
          viewBox="0 0 16 16">
          <path fill-rule="evenodd"
            d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z" />
          <path fill-rule="evenodd"
            d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z" />
        </svg>
        <div class="pl-2"></div>
        خانه
      </router-link>
    </li>
    <li v-if="ifTeacher() || ifboth()">
      <router-link to="/mycourses">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-card-list"
          viewBox="0 0 16 16">
          <path
            d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
          <path
            d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
        </svg>
        <div class="pl-2"></div>
        دوره های من
      </router-link>
    </li>
    <li>
      <router-link to="/my-online-classes">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
          class="bi bi-file-earmark-slides" viewBox="0 0 16 16">
          <path
            d="M5 6a.5.5 0 0 0-.496.438l-.5 4A.5.5 0 0 0 4.5 11h3v2.016c-.863.055-1.5.251-1.5.484 0 .276.895.5 2 .5s2-.224 2-.5c0-.233-.637-.429-1.5-.484V11h3a.5.5 0 0 0 .496-.562l-.5-4A.5.5 0 0 0 11 6H5zm2 3.78V7.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 9.778z" />
          <path
            d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
        </svg>
        <div class="pl-2"></div>
        کلاس های آنلاین من
      </router-link>
    </li>
    <li v-if="ifTeacher() || ifboth()">
      <router-link to="/save-course">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-file-plus"
          viewBox="0 0 16 16">
          <path d="M8.5 6a.5.5 0 0 0-1 0v1.5H6a.5.5 0 0 0 0 1h1.5V10a.5.5 0 0 0 1 0V8.5H10a.5.5 0 0 0 0-1H8.5V6z" />
          <path
            d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
        </svg>
        <div class="pl-2"></div>
        ایجاد دوره
      </router-link>
    </li>
    <li v-if="ifTranslator() || ifboth()">
      <router-link to="/myarticles">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-pencil-square"
          viewBox="0 0 16 16">
          <path
            d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
          <path fill-rule="evenodd"
            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
        </svg>
        <div class="pl-2"></div>
        پروژه
      </router-link>
    </li>
    <li>
      <router-link to="/finance">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-coin"
          viewBox="0 0 16 16">
          <path
            d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z" />
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
          <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z" />
        </svg>
        <div class="pl-2"></div>
        گزارشات مالی
      </router-link>
    </li>
    <li>
      <router-link to="/ticket">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-chat-right-quote"
          viewBox="0 0 16 16">
          <path
            d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z" />
          <path
            d="M7.066 4.76A1.665 1.665 0 0 0 4 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z" />
        </svg>
        <div class="pl-2"></div>
        پشتیبانی
      </router-link>
    </li>
    <li>
      <router-link to="/profile">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-person-circle"
          viewBox="0 0 16 16">
          <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
          <path fill-rule="evenodd"
            d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
        </svg>
        <div class="pl-2"></div>

        پروفایل من
      </router-link>
    </li>
    <li style="cursor: pointer">
      <a class="crToPoi primCom black-logOut" data-toggle="modal" data-target="#modalLogout">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-door-open"
          viewBox="0 0 16 16">
          <path d="M8.5 10c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1z" />
          <path
            d="M10.828.122A.5.5 0 0 1 11 .5V1h.5A1.5 1.5 0 0 1 13 2.5V15h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V1.5a.5.5 0 0 1 .43-.495l7-1a.5.5 0 0 1 .398.117zM11.5 2H11v13h1V2.5a.5.5 0 0 0-.5-.5zM4 1.934V15h6V1.077l-6 .857z" />
        </svg>
        <div class="pl-2"></div>

        خروج
      </a>
    </li>
  </ul><span class="text-center">{{ version }}</span>
  <div @click="closeMenu()" class="logo-box d-flex justify-content-center align-items-center">
    <router-link to="/" class="logo"><img :width="200" :height="59" src="../assets/images/logo-fill.png"
        alt="هاوبیر" /></router-link>
  </div>
</template>

<script>
import ls from "localstorage-slim";
import router from "../router/index";
import { DOMAIN, VERSION } from "../configs";
export default {
  name: "NavBar",
  data() {
    return {
      theme: "light",
      domain: DOMAIN,
      version: VERSION,
      failedPic: false,
      me: {},
      loggedOut: true,
      UserType: "",
    };
  },
  methods: {
    ifPicExist(p) {
      if (p === "no" || p === undefined || p === null) {
        return false;
      } else {
        return true;
      }
    },
    ifTeacher() {
      return this.UserType === 0;
    },
    ifTranslator() {
      return this.UserType === 1;
    },
    ifboth() {
      return this.UserType === 2;
    },
    // togglee(){
    //     var x = document.getElementById("listitems");
    //     if (x.style.display === "none") {
    //         x.style.display = "block";
    //     } else {
    //         x.style.display = "none";
    //     }
    // }
    logOut() {
      ls.clear();
      localStorage.clear();
      router.push("/login");
    },
    getCredentials() {
      if (JSON.parse(ls.get("user"))) {
        this.me = JSON.parse(ls.get("user"));
        this.loggedOut = false;
        this.UserType = this.me.Type;
      } else {
        this.logOut()
      }
    },
  },
  beforeMount() {
    this.theme = localStorage.getItem("theme");

    this.getCredentials();
  },
};
</script>

<style>
/* ul li ul {
    display: none;
}

ul li:hover ul {
    display: block;
} */
</style>
